import moment from "moment";

export const quantityHistoryColumns = [
    { value: 'Date', label: 'Date', firstRow: true },
    { value: 'Mouvement', label: 'Mouvement', firstRow: true },
    { value: 'Quantité', label: 'Quantité', firstRow: true },
    { value: 'Dépot', label: 'Dépot', firstRow: true },
    { value: 'Quantité actuelle', label: 'Quantité actuelle', firstRow: false }
];

export const etatStockColumns = [
    { value: 'Date mise à jour', label: 'Date mise à jour', firstRow: true },
    { value: 'Nom Article', label: 'Nom Article', firstRow: true },
    { value: 'Nom Dépots', label: 'Nom Dépots', firstRow: true },
    { value: 'Quantité', label: 'Quantité', firstRow: true },
    { value: 'valeur', label: 'valeur', firstRow: true },
    { value: 'Total', label: 'Total', firstRow: false }
];

const ecColumns = [
    { value: 'Date d\'opération', label: 'Date d\'opération', firstRow: true },
    { value: 'Numéro de la piéce', label: 'Numéro de la piéce', firstRow: true },
    // {value: 'Numéro de facture', label: 'Numéro de facture', firstRow: true},
    { value: 'Numéro de compte', label: 'Numéro de compte', firstRow: true },
    { value: 'Sous compte', label: 'Sous compte', firstRow: true },
    { value: 'Libellé écriture', label: 'Libellé écriture', firstRow: true },
    { value: 'Débit', label: 'Débit', firstRow: true },
    { value: 'Crédit', label: 'Crédit', firstRow: true }
];

export const invoiceStatusHistoryColumns = [
    { value: 'Date', label: 'Date', firstRow: true },
    { value: 'Status du facture', label: 'Status du facture', firstRow: true },
    { value: 'Mode de reglement', label: 'Mode de reglement', firstRow: true },
    { value: 'Montant payé', label: 'Montant payé', firstRow: true },
    { value: 'Reste à payer', label: 'Reste à payer', firstRow: true }
];

/**
 * Export Csv historique de paiement
 *
 * @param dataz
 * @param currency
 * @param invoiceNumber
 * @return {boolean}
 */
export const exportInvoiceStatusHistory = (data, invoiceNumber, currency) => {
    /**
     *
     * @type {*[]}
     */
    let dataToExport = [];
    console.log("data: ", data)
    //set 1st row
    setFirstRow(dataToExport, invoiceStatusHistoryColumns);

    //data rows
    for (let i = 0; i < data.length; i++) {
        dataToExport.push([
            moment(new Date(data[i].created_at)).format("DD/MM/YYYY"),
            data[i].status.name,
            data[i].status.id === 1 ? '' : data[i].payment_account.code + " " + data[i].payment_account.name,
            data[i].payed_amount === null ? '' : data[i].status.id === 2 ? data[i].rap + " " + currency : data[i].payed_amount + " " + currency,
            data[i].status.id === 2 ? 0 : data[i].rap + " " + currency,
        ]);
    }

    //export data
    return exportCsv(dataToExport, "historique_paiement_" + invoiceNumber + ".csv", ["Historique du paiement de la facture no : " + invoiceNumber]);
}

/**
 *
 * @param code
 * @return {boolean}
 */
const isBqSousCompte = (code) => {
    return code.substring(0, 4) === '5141';
}

/**
 *
 * @param code
 * @return {boolean}
 */
const isCsSousCompte = (code) => {
    return code.substring(0, 4) === '5161';
}

/**
 * export journal based on loaded ecs
 *
 * @param {array} ecs
 * @param {string} userFilterOption
 * @param {string} header
 * @param {boolean} exportAllJr
 * @param {array} exportAllJrData
 */
export const exportJr = (ecs, userFilterOption, header, exportAllJr = false, exportAllJrData = []) => {
    console.log("user filter option is , ", userFilterOption);
    let journalToExportFa = [];
    let journalToExportFv = [];
    let journalToExportBq = [];
    let journalToExportCs = [];
    let journalToExportRan = [];
    let journalToExportOd = [];

    let journalToExport = [];
    let ec = [];
    let totalDebit = 0;
    let totalCredit = 0;
    //set 1st row
    setFirstRow(journalToExport, ecColumns);
    if (userFilterOption !== null) {
        if (['FA', 'FV'].includes(userFilterOption)) {
            for (let i = 0; i < ecs.length; i++) {
                let returnedDataToExport = exportEc([ecs[i]], [], [], '', true);
                journalToExport = [...journalToExport, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
            }
        } else if (['BQ', 'CS', 'ALLBQ', 'ALLCS'].includes(userFilterOption) || isBqSousCompte(userFilterOption) || isCsSousCompte(userFilterOption)) {
            for (let i = 0; i < ecs.length; i++) {
                if (ecs[i].isSousCompteBqCs !== undefined && ecs[i].isSousCompteBqCs) {
                    let returnedDataToExport = exportEc([], [], [ecs[i]], '', true);
                    journalToExport = [...journalToExport, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
                } else {
                    let returnedDataToExport = exportEc([], [ecs[i]], [], '', true);
                    journalToExport = [...journalToExport, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
                }
            }
        } else if (['RAN', 'OD'].includes(userFilterOption)) {
            for (let i = 0; i < ecs.length; i++) {
                let returnedDataToExport = exportEc([ecs[i]], [], [], '', true);
                journalToExport = [...journalToExport, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
            }
        } else if (userFilterOption === 'all') {
            //FA
            journalToExportFa = [...journalToExportFa, ['Journal Comptable des Achats', '', '', '', '', '', '']];

            for (let i = 0; i < exportAllJrData[0].length; i++) {
                let returnedDataToExport = exportEc([exportAllJrData[0][i]], [], [], '', true);
                journalToExportFa = [...journalToExportFa, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]

            }
            journalToExportFa = [...journalToExportFa, ['', '', '', '', 'Totaux', setJrFooter(journalToExportFa, true).total_debit, setJrFooter(journalToExportFa, true).total_credit]]

            //FV
            journalToExportFv = [...journalToExportFv, ['Journal Comptable des Ventes', '', '', '', '', '', '']];

            for (let i = 0; i < exportAllJrData[1].length; i++) {
                let returnedDataToExport = exportEc([exportAllJrData[1][i]], [], [], '', true);
                journalToExportFv = [...journalToExportFv, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
            }
            journalToExportFv = [...journalToExportFv, ['', '', '', '', 'Totaux', setJrFooter(journalToExportFv, true).total_debit, setJrFooter(journalToExportFv, true).total_credit]]

            //BQ
            journalToExportBq = [...journalToExportBq, ['Journal Comptable de la Banque', '', '', '', '', '', '']];

            for (let i = 0; i < exportAllJrData[2].length; i++) {
                if (exportAllJrData[2][i].isSousCompteBqCs !== undefined && exportAllJrData[2][i].isSousCompteBqCs) {
                    let returnedDataToExport = exportEc([], [], [exportAllJrData[2][i]], '', true);
                    journalToExportBq = [...journalToExportBq, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
                } else {
                    let returnedDataToExport = exportEc([], [exportAllJrData[2][i]], [], '', true);
                    journalToExportBq = [...journalToExportBq, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
                }
            }
            journalToExportBq = [...journalToExportBq, ['', '', '', '', 'Totaux', setJrFooter(journalToExportBq, true).total_debit, setJrFooter(journalToExportBq, true).total_credit]]

            //CS
            journalToExportCs = [...journalToExportCs, ['Journal Comptable de la Caisse', '', '', '', '', '', '']];

            for (let i = 0; i < exportAllJrData[3].length; i++) {
                if (exportAllJrData[3][i].isSousCompteBqCs !== undefined && exportAllJrData[3][i].isSousCompteBqCs) {
                    let returnedDataToExport = exportEc([], [], [exportAllJrData[3][i]], '', true);
                    journalToExportCs = [...journalToExportCs, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
                } else {
                    let returnedDataToExport = exportEc([], [exportAllJrData[3][i]], [], '', true);
                    journalToExportCs = [...journalToExportCs, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
                }
            }
            journalToExportCs = [...journalToExportCs, ['', '', '', '', 'Totaux', setJrFooter(journalToExportCs, true).total_debit, setJrFooter(journalToExportCs, true).total_credit]]

            //RAN
            journalToExportRan = [...journalToExportRan, ['Journal Comptable du Raport à nouveau', '', '', '', '', '', '']];

            for (let i = 0; i < exportAllJrData[4].length; i++) {
                let returnedDataToExport = exportEc([exportAllJrData[4][i]], [], [], '', true);
                journalToExportRan = [...journalToExportRan, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
            }
            journalToExportRan = [...journalToExportRan, ['', '', '', '', 'Totaux', setJrFooter(journalToExportRan, true).total_debit, setJrFooter(journalToExportRan, true).total_credit]]

            //OD
            journalToExportOd = [...journalToExportOd, ['Journal Comptable des Opération diverses', '', '', '', '', '', '']];

            for (let i = 0; i < exportAllJrData[5].length; i++) {
                let returnedDataToExport = exportEc([exportAllJrData[5][i]], [], [], '', true);
                journalToExportOd = [...journalToExportOd, ...returnedDataToExport[0], ...returnedDataToExport[1], ...returnedDataToExport[2]]
            }
            journalToExportOd = [...journalToExportOd, ['', '', '', '', 'Totaux', setJrFooter(journalToExportOd, true).total_debit, setJrFooter(journalToExportOd, true).total_credit]]


            //console.log([...journalToExportOd],[...journalToExportRan],[...journalToExportCs],[...journalToExportBq],[...journalToExportFa]);

        }


    }
    //setJrFooter(journalToExport);

    if (exportAllJr)
        journalToExport = [...journalToExport, ...journalToExportFa, ...journalToExportFv, ...journalToExportBq, ...journalToExportCs, ...journalToExportRan, ...journalToExportOd]
    else
        journalToExport = [...journalToExport, ['', '', '', '', 'Totaux', setJrFooter(journalToExport).total_debit, setJrFooter(journalToExport).total_credit]]


    // exportCsv(journalToExport, "journal_comptable.csv", [header]);
    exportCsv(journalToExport, "journal_comptable.csv", header.split(","));
}

const setJrFooter = (array, exportAllJr = false) => {
    let totalDebit = 0;
    let totalCredit = 0;

    for (let i = exportAllJr ? 0 : 1; i < array.length; i++) {
        totalDebit += array[i][5] === '' || isNaN(array[i][5]) ? 0 : parseFloat(array[i][5]);
        totalCredit += array[i][6] === '' || isNaN(array[i][6]) ? 0 : parseFloat(array[i][6]);
    }

    return {
        "total_debit": totalDebit.toFixed(2),
        "total_credit": totalCredit.toFixed(2)
    };
}
export const exportEc2 = () => {
    const csvRows = [];
    const table = document.querySelector('.tableec');
    const rows = table.querySelectorAll('tr');

    rows.forEach(row => {
        const csvRow = [];
        row.querySelectorAll('th').forEach(cell => {
            const cellContent = [];
            cell.childNodes.forEach(node => {
                if (node.nodeType === Node.TEXT_NODE) {
                    cellContent.push(node.textContent.trim());
                }
            });
            csvRow.push(cellContent.join(' ')); // Combine nested text content
        });
        csvRows.push(csvRow.join(','));
    });

    const csvData = csvRows.join('\n');
    const blob = new Blob([csvData], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('href', url);
    a.setAttribute('download', 'table-data.csv');
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
}

/**
 *
 * @param fPiece
 * @param header
 * @return {boolean}
 */
export const exportEcPourPiece = (fPiece, header) => {
    console.log("fPiece =", fPiece);
    console.log("fPiece[0] =", fPiece[0]);

    let dataToExportPiece = [];
    setFirstRow(dataToExportPiece, ecColumns);

    if (fPiece.length > 0 && fPiece[0] != null) {

        for (let i = 0; i < fPiece[0]['credit'][0].length; i++) {
            if (i === 0) {
                dataToExportPiece.push([
                    fPiece[0].date_creation,
                    fPiece[0].no_piece,
                    // fPiece[0].invoice_number,
                    fPiece[0]['accounts'][0][i],
                    "",
                    fPiece[0].libelle_fournisseur,
                    fPiece[0]['debit'][0][i],
                    fPiece[0]['credit'][0][i]
                ]);
            } else {
                dataToExportPiece.push([
                    "",
                    "",
                    fPiece[0]['accounts'][0][i],
                    "",
                    "",
                    fPiece[0]['debit'][0][i],
                    fPiece[0]['credit'][0][i]
                ]);
            }
        }
    }

    return exportCsv(dataToExportPiece, "ecriture_comptable.csv", [header]);
}

/**
 * export ec csv
 *
 * @param {array} fEco
 * @param {array} fFin
 * @param {array} fPiece
 * @param {string} header
 * @param {boolean} isJournal
 */
export const exportEc = (fEco, fFin, fPiece, header, isJournal = false) => {
    /**
     *
     * @type {*[]}
     */
    let dataToExport = [];
    let dataToExportEco = [];
    let dataToExportFin = [];
    let dataToExportPiece = [];
    let totalEcoDebit = 0;
    let totalEcoCredit = 0;
    let arrayLength = 0;
    let isPiece = false;
    /**
     *
     * @type {number}
     */
    let totalStock = 0;
    //Prepare Data

    //set 1st row
    if (!isJournal)
        setFirstRow(dataToExport, ecColumns);

    //get ec array length (for example we have 2 products in this invoice, this will involve 2 tax+2cc = 4 + 1 (first row) => length = 5
    if (isJournal) {
        if (fEco[0] != null) {
            if (fEco[0]['from'] !== "invoice_module") {
                //this is piece, so don't search for flux eco
                isPiece = true;
                fPiece = fEco;
            } else {
                arrayLength = (fEco[0]['compte_tva'].length * 2) + 1;
            }
        }
    } else {
        arrayLength = (fEco[0]['compte_tva'].length * 2) + 1;
    }

    console.log("arrayLength: ", arrayLength, fEco.length)

    //this will count the iteration of taxes and cc
    let count = 0;
    let countCompteCharge = 0;
    //init
    let debit = "";
    let credit = "";

    /**
     * FLUX ECO
     * */

    if (fEco.length > 0 && fEco[0] != null && arrayLength > 0 && !isPiece) {

        //set first row as flux type
        if (!isJournal)
            setFluxTypeHeader(dataToExportEco, "Flux économique");
        //data rows
        for (let i = 0; i < arrayLength; i++) {

            if (i === 0) {
                if (fEco[0].invoice_type === "achat" || fEco[0].invoice_type === "depense") {
                    dataToExportEco.push([
                        fEco[0].date_creation,
                        //moment(new Date(fEco[0].date_creation)).format("DD/MM/YYYY"),
                        fEco[0].no_piece,
                        fEco[0].compte_fournisseur,
                        `'${fEco[0].sous_compte}`, //start with ' cause if not this value if it contains mathematics figures it will be interpreted not as a string value
                        fEco[0].libelle_fournisseur,
                        "",
                        fEco[0].total_ttc
                    ]);

                } else {
                    dataToExportEco.push([
                        moment(new Date(fEco[0].date_creation)).format("DD/MM/YYYY"),
                        fEco[0].no_piece,
                        fEco[0].compte_fournisseur,
                        `'${fEco[0].sous_compte}`, //start with ' cause if not this value if it contains mathematics figures it will be interpreted not as a string value
                        fEco[0].libelle_fournisseur,
                        fEco[0].total_ttc,
                        ""
                    ]);
                }
                totalEcoCredit += fEco[0].total_ttc;
            } else {
                if (fEco[0].invoice_type === "achat" || fEco[0].invoice_type === "depense") {
                    debit = fEco[0]['total_ht_et_tva'][i];
                    credit = "";
                } else {
                    debit = "";
                    credit = fEco[0]['total_ht_et_tva'][i];
                }

                if (count === ((arrayLength - 1) / 2)) {
                    dataToExportEco.push([
                        "",
                        "",
                        fEco[0]['compte_compte_de_charge'][countCompteCharge],
                        "",
                        "",
                        debit,
                        credit
                    ]);
                    countCompteCharge++;
                } else {
                    dataToExportEco.push([
                        "",
                        "",
                        fEco[0]['compte_tva'][count],
                        "",
                        "",
                        debit,
                        credit
                    ]);
                    count++;
                }
                totalEcoDebit += fEco[0]['total_ht_et_tva'][i];

            }
        }
    }

    /**
     * PIECE
     * */
    if (fPiece.length > 0 && fPiece[0] != null) {
        // dataToExportPiece.push([
        //     fPiece[0].date_creation,
        //     fPiece[0].no_piece,
        //     fPiece[0].compte_fournisseur,
        //     "",
        //     fPiece[0].libelle_fournisseur,
        //     "",
        //     ""
        // ]);

        for (let i = 0; i < fPiece[0]['credit'][0].length; i++) {
            if (i === 0) {
                dataToExportPiece.push([
                    fPiece[0].date_creation,
                    fPiece[0].no_piece,
                    fPiece[0]['accounts'][0][i],
                    "",
                    fPiece[0].libelle_fournisseur,
                    fPiece[0]['debit'][0][i],
                    fPiece[0]['credit'][0][i]
                ]);
            } else {
                dataToExportPiece.push([
                    "",
                    "",
                    fPiece[0]['accounts'][0][i],
                    "",
                    "",
                    fPiece[0]['debit'][0][i],
                    fPiece[0]['credit'][0][i]
                ]);
            }

        }
    }

    /**
     * FLUX FIN
     * */
    if (fFin.length > 0) {
        console.log("%%%%%%%%%%%%%% export csv3");
        console.log("fFin is : ", fFin);

        if (!isJournal)
            setFluxTypeHeader(dataToExportFin, "Flux financier");
        let max = 0;

        for (let i = 0; i < fFin.length; i++) {
            max = 0;
            if (fFin[i].payment_account === '51410000' || isBqSousCompte(fFin[i].payment_account)) {
                console.log("%%%%%%%%%%%%%% export csv3-2");

                max = 3;
                for (let j = 0; j < max; j++) {
                    if (j === 0) {
                        dataToExportFin.push([
                            fFin[i].date_creation,
                            fFin[i].no_piece,
                            fFin[i].compte_fournisseur,
                            `'${fFin[i].sous_compte}`,
                            fFin[i].banquePaymentOption + (fFin[i].banquePaymentOption === "chéque" ? ' - ' + fFin[i].chequeId : ""),
                            (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? Number(fFin[i].total_ttc).toFixed(2) : "",
                            (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? "" : Number(fFin[i].total_ttc).toFixed(2)
                        ]);
                    } else if (j === 1) {
                        dataToExportFin.push([
                            "",
                            "",
                            fFin[i].payment_account,
                            "",
                            "",
                            (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? "" : Number(fFin[i].total_ttc).toFixed(2),
                            (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? Number(fFin[i].total_ttc).toFixed(2) : ""
                        ]);
                    } else {
                        dataToExportFin.push([
                            "",
                            "",
                            fFin[i].banquePaymentOption + (fFin[i].banquePaymentOption === "chéque" ? ' - ' + fFin[i].chequeId : ""),
                            "",
                            "",
                            "",
                            ""
                        ]);
                    }
                }


            } else {
                console.log("%%%%%%%%%%%%%% export csv4");
                max = 2;
                for (let j = 0; j < max; j++) {
                    if (j === 0) {
                        dataToExportFin.push([
                            fFin[i].date_creation,
                            fFin[i].no_piece,
                            fFin[i].compte_fournisseur,
                            `'${fFin[i].sous_compte}`, //fFin[i].sous_compte,
                            fFin[i].libelle_fournisseur,
                            (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? Number(fFin[i].total_ttc).toFixed(2) : fFin[i].invoice_type === "piece" ? fFin[i].debit : "",
                            (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? "" : fFin[i].invoice_type === "piece" ? fFin[i].credit : Number(fFin[i].total_ttc).toFixed(2)
                        ]);
                    } else {
                        if (fFin[i].nature !== "is_bq_cs") {
                            dataToExportFin.push([
                                "",
                                "",
                                fFin[i].payment_account,
                                "",
                                "",
                                (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? "" : Number(fFin[i].total_ttc).toFixed(2),
                                (fFin[i].invoice_type === "achat" || fFin[i].invoice_type === "depense") ? Number(fFin[i].total_ttc).toFixed(2) : ""
                            ]);
                        }
                    }
                }
            }
        }
    }

    if (!isJournal)
        dataToExport = [...dataToExport, ...dataToExportEco, ...dataToExportPiece, ...dataToExportFin];
    else
        dataToExport = [dataToExportEco, dataToExportPiece, dataToExportFin];


    if (!isJournal) {
        return exportCsv(dataToExport, "ecriture_comptable.csv", [header]);
    } else {
        return dataToExport;
    }

}

/**
 * état de stock
 *
 * @param {array} columns
 * @param {array} data
 * @param {string} header
 *
 * @return Boolean
 */
export const exportStockState = (columns, data, header) => {
    /**
     *
     * @type {*[]}
     */
    let dataToExport = [];

    /**
     *
     * @type {number}
     */
    let totalStock = 0;
    let totalV = 0
    //Prepare Data
    //set 1st row
    setFirstRow(dataToExport, etatStockColumns);

    //data rows
    for (let i = 0; i < data.length; i++) {
        totalStock += parseInt(data[i].qty);
        totalV += parseFloat(data[i].qty) * data[i].costPrice;

        const baseRow = [
            moment(new Date(data[i].updated_at)).format("DD/MM/YYYY"),
            data[i].name.replace(/,/g, " ")
        ];

        if (Array.isArray(data[i].depot)) {
            for (let j = 0; j < data[i].depot.length; j++) {
                dataToExport.push([
                    ...baseRow,
                    data[i].depot[j].depot.name.replace(/,/g, " "),
                    data[i].depot[j].quantity,
                    parseFloat(data[i].depot[j].quantity) * data[i].costPrice,
                ]);
            }
        }
    }


    //set last row
    if (columns.some(column => column.value === 'Total')) {
        setLastRow(dataToExport, ['Total', , totalStock, totalV]);
    }

    //export data
    return exportCsv(dataToExport, "etat_stock.csv", [header]);

}
/**
 * export qty
 *
 * @param {array} columns
 * @param {array} data
 * @param {string} header
 *
 * @return Boolean
 */
export const exportQuantityHistory = (columns, data, header) => {
    /**
     *
     * @type {*[]}
     */
    let dataToExport = [];

    /**
     *
     * @type {number}
     */
    let currentQty = 0;
    //Prepare Data
    //set 1st row
    setFirstRow(dataToExport, quantityHistoryColumns);

    //data rows
    for (let i = 0; i < data.length; i++) {
        currentQty = data[i].is_init && data[i].is_init === 1 ? currentQty + parseInt(data[i].qty) : data[i].type === 'achat' || data[i].type === 'avoir' ? currentQty + parseInt(data[i].qty) : currentQty - parseInt(data[i].qty);

        dataToExport.push([
            moment(new Date(data[i].created_at)).format("DD/MM/YYYY"),
            data[i].is_init && data[i].is_init === 1 ? "Q.S.INITIAL" : data[i].type === 'achat' ? "Q.ACHAT (+)" : data[i].type === 'avoir' ? "Q.FACTURE D'AVOIR (+)" : "Q.VENTE (-)",
            data[i].is_init && data[i].is_init === 1 ? data[i].depot?.name.replace(/,/g, " ") : data[i].type === 'achat' || data[i].type === 'avoir' ? data[i].depot.name.replace(/,/g, " ") : data[i].depot.name.replace(/,/g, " "),
            data[i].is_init && data[i].is_init === 1 ? "+" + data[i].qty : data[i].type === 'achat' || data[i].type === 'avoir' ? "+" + data[i].qty : "-" + data[i].qty
        ]);

    }

    //filter Data to return only selected columns
    //let filteredData = getSelectedCols(dataToExport, columns, quantityHistoryColumns);

    //set last row
    if (columns.some(column => column.value === 'Quantité actuelle')) {
        setLastRow(dataToExport, ['Quantité actuelle', currentQty]);
    }

    //console.log("filteredData to export : ",filteredData);

    //export data
    return exportCsv(dataToExport, "historique_quantité.csv", [header]);
}

/**
 * set last row
 *
 * @param {array} data
 * @param {array} elt
 */
const setLastRow = (data, elt) => {
    data.push(elt);
}

const setFluxTypeHeader = (data, type) => {
    data.push(
        [
            type,
            "",
            "",
            "",
            "",
            "",
            ""
        ]
    );
}

/**
 * set 1st row, to define first rows, they has to have a firstRow attribute as true
 *
 * @param {array} data
 * @param {array} cols
 */
const setFirstRow = (data, cols) => {
    const firstRowValues = cols.filter(column => column.firstRow).map(column => column.value);
    data.push(firstRowValues);
}

/**
 * export csv file from array
 *
 * @param {array} data
 * @param {string} fileName
 * @param {array} header
 */
export const exportCsv = (data, fileName, header) => {
    try {
        /**
         * Ajout du BOM pour l'encodage UTF-8
         * @type {string}
         */
        const BOM = "\uFEFF";

        /**
         * Fonction pour échapper les valeurs contenant des caractères spéciaux
         * @param {string} value
         * @returns {string}
         */
        const escapeValue = (value) => {
            if (typeof value === "string" && (value.includes(";") || value.includes('"') || value.includes("\n"))) {
                return `"${value.replace(/"/g, '""')}"`;
            }
            return value;
        };

        // Utilisation du séparateur `;`
        // let csvContent = BOM + header.map(escapeValue).join(";") + "\n" +
        //     data.map(row => row.map(escapeValue).join(";")).join("\n");
        // les cellules de tables CSV
      let csvContent = BOM +
    "sep=;\n" +
    header.map(escapeValue).join(";") + "\n" +
    data.map(row => row.map(escapeValue).join(";")).join("\n");
        /**
         * Création d'un Blob pour le contenu CSV
         * @type {Blob}
         */
        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

        /**
         * Création d'une URL pour le Blob
         * @type {string}
         */
        const url = URL.createObjectURL(blob);

        /**
         * Création et téléchargement du fichier
         * @type {HTMLAnchorElement}
         */
        const link = document.createElement("a");
        link.setAttribute("href", url);
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // Nettoyage de l'URL après le téléchargement
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        return true;
    } catch (e) {
        console.error("error while exporting csv :", e);
        return false;
    }
}

/**
 *
 * @param dataToExport
 * @param userSelectedColumns
 * @param allColumns
 * @returns {array}
 */
const getSelectedCols = (dataToExport, userSelectedColumns, allColumns) => {
    /**
     *
     * @type {*[]}
     */
    const columnIndexMap = [];

    // get indices of selected columns
    allColumns.forEach((column, index) => {
        //check for a condition on an array and wants to know if at least one element fulfills that condition
        //condition is: selectedColumn.value in columns array === column.value in quantityHistoryColumns
        if (userSelectedColumns.some(selectedColumn => selectedColumn.value === column.value)) {
            columnIndexMap[column.value] = index;
        }
    });

    // Filter data based on selected columns
    return dataToExport.map(row => {
        return userSelectedColumns.map(selectedColumn => {
            const columnIndex = columnIndexMap[selectedColumn.value];
            return columnIndex !== undefined ? row[columnIndex] : '';
        });
    });
}

export const ecColumnsSelectOptions = [
    { value: 'Flux économique', label: 'Flux économique', firstRow: true },
    { value: 'Flux financier', label: 'Flux financier', firstRow: true }
];

const glColumns = [
    { value: 'Date', label: 'Date', firstRow: true },
    { value: 'C.j', label: 'C.j', firstRow: true },
    { value: 'N° pièce', label: 'N° pièce', firstRow: true },
    { value: 'Libellé écriture', label: 'Libellé écriture', firstRow: true },
    { value: 'Mouvement débit', label: 'Mouvement débit', firstRow: true },
    { value: 'Mouvement crédit', label: 'Mouvement crédit', firstRow: true },
    { value: 'Solde progressif', label: 'Solde progressif', firstRow: true }
];

export const exportGlCsv = (data) => {
    let gLToExport = [];
    let total_debit_generale = 0;
    let total_credit_generale = 0;

    // Ajouter les en-têtes
    setFirstRow(gLToExport, glColumns);

    for (let i = 0; i < data.length; i++) {
        let solde_progres = 0;
        let total_debit = 0;
        let total_credit = 0;

        // Ajouter le compte comptable
        gLToExport.push([
            `"${data[i]['acc']['code']}"`, // Code du compte
            data[i]['acc']['name'],       // Nom du compte
            '', '', '', '', ''            // Colonnes vides pour alignement
        ]);

        for (let j = 0; j < data[i]['data'].length; j++) {
            let debit = 0;
            let credit = 0;

            if (data[i]['data'][j].module === 'piece' || (data[i]['data'][j].is_gr_tiers != null && data[i]['data'][j].is_gr_tiers)) {
                solde_progres += parseFloat(data[i]['data'][j].debit || 0);
                solde_progres -= parseFloat(data[i]['data'][j].credit || 0);

                debit = parseFloat(data[i]['data'][j].debit || 0);
                credit = parseFloat(data[i]['data'][j].credit || 0);
            } else {
                solde_progres = data[i]['data'][j].debit === true
                    ? solde_progres + parseFloat(data[i]['data'][j].total_ht)
                    : solde_progres - parseFloat(data[i]['data'][j].total_ht);

                debit = data[i]['data'][j].debit === true ? parseFloat(data[i]['data'][j].total_ht) : 0;
                credit = data[i]['data'][j].credit === true ? parseFloat(data[i]['data'][j].total_ht) : 0;
            }

            total_debit += debit;
            total_credit += credit;

            // Ajouter les lignes de données
            gLToExport.push([
                data[i]['data'][j].date_creation,                     // Date
                getTransactionCj(data[i]['data'][j].invoice_type),    // C.j
                data[i]['data'][j].no_piece,                          // N° pièce
                data[i]['data'][j].libelle || "",                     // Libellé écriture
                debit.toFixed(2),                                     // Mouvement débit
                credit.toFixed(2),                                    // Mouvement crédit
                solde_progres.toFixed(2)                              // Solde progressif
            ]);

            if (j === data[i]['data'].length - 1) {
                // Ajouter le total pour le compte
                gLToExport.push([
                    '', '', '', `Total compte ${data[i]['acc']['code']}`,
                    total_debit.toFixed(2), total_credit.toFixed(2), solde_progres.toFixed(2)
                ]);
                total_debit_generale += total_debit;
                total_credit_generale += total_credit;
            }
        }
    }

    // Ajouter les totaux généraux
    gLToExport.push([
        '', '', '', 'Totaux',
        total_debit_generale.toFixed(2), total_credit_generale.toFixed(2), ''
    ]);

    // Exporter le fichier CSV
    exportCsv(gLToExport, "grand_livre_comptable.csv", ['Grand Livre Comptable']);
};

const getTransactionCj = (type) => {
    if (type === 'vente') {
        return 'VTE';
    } else if (type === 'achat') {
        return 'ACH';
    } else if (type === 'depense') {
        return 'ACH';
    } else if (type === 'Operation Diverses') {
        return 'OD';
    } else if (type === 'Report à Nouveaux') {
        return 'RAN';
    }
}

export const exportBalanceAccountsCsv = (accountsData) => {
    const csvData = [];
    const headers = [
        "Numéro de compte",
        "Intitulé des comptes",
        "Mouvements Débit",
        "Mouvements Crédit",
        "Soldes Débit",
        "Soldes Crédit",
    ];
    csvData.push(headers);

    let grandTotalMvDebit = 0;
    let grandTotalMvCredit = 0;
    let grandTotalSdDebit = 0;
    let grandTotalSdCredit = 0;

    let totalCompteBilanDebit = 0;
    let totalCompteBilanCredit = 0;
    let totalCompteGestionDebit = 0;
    let totalCompteGestionCredit = 0;

    accountsData.forEach((account) => {
        let totalDebit = 0;
        let totalCredit = 0;
        let soldeDebit = 0;
        let soldeCredit = 0;

        account?.data?.map((transaction) => {
            console.log("transaction ", transaction);

            if (transaction.is_gr_tiers) {
                totalDebit += parseFloat(transaction.debit) || 0;
                totalCredit += parseFloat(transaction.credit) || 0;
            } else {
                if (transaction.module === "invoice") {
                    totalDebit += transaction.debit === true ? parseFloat(transaction.total_ht) || 0 : 0;
                    totalCredit += transaction.credit === true ? parseFloat(transaction.total_ht) || 0 : 0;
                } else {
                    totalDebit += parseFloat(transaction.debit) || 0;
                    totalCredit += parseFloat(transaction.credit) || 0;
                }
            }
        });


        const solde = totalDebit - totalCredit;
        if (solde > 0) {
            soldeDebit = solde;
        } else {
            soldeCredit = -solde;
        }

        grandTotalMvDebit += totalDebit;
        grandTotalMvCredit += totalCredit;
        grandTotalSdDebit += soldeDebit;
        grandTotalSdCredit += soldeCredit;

        // Classify accounts into "Bilan" or "Gestion"
        if (["1", "2", "3", "4", "5"].includes(account.acc.code[0])) {
            totalCompteBilanDebit += totalDebit;
            totalCompteBilanCredit += totalCredit;
        } else if (["6", "7"].includes(account.acc.code[0])) {
            totalCompteGestionDebit += totalDebit;
            totalCompteGestionCredit += totalCredit;
        }

        csvData.push([
            account.acc.code,
            account.acc.name,
            totalDebit.toFixed(2),
            totalCredit.toFixed(2),
            soldeDebit.toFixed(2),
            soldeCredit.toFixed(2),
        ]);
    });

    // Add totals for "Bilan" accounts
    csvData.push([
        "Totaux comptes de bilan",
        "",
        totalCompteBilanDebit.toFixed(2),
        totalCompteBilanCredit.toFixed(2),
        (totalCompteBilanDebit - totalCompteBilanCredit > 0
            ? (totalCompteBilanDebit - totalCompteBilanCredit).toFixed(2)
            : "0.00"),
        (totalCompteBilanDebit - totalCompteBilanCredit < 0
            ? (totalCompteBilanCredit - totalCompteBilanDebit).toFixed(2)
            : "0.00"),
    ]);

    // Add totals for "Gestion" accounts
    csvData.push([
        "Totaux comptes de gestion",
        "",
        totalCompteGestionDebit.toFixed(2),
        totalCompteGestionCredit.toFixed(2),
        (totalCompteGestionDebit - totalCompteGestionCredit > 0
            ? (totalCompteGestionDebit - totalCompteGestionCredit).toFixed(2)
            : "0.00"),
        (totalCompteGestionDebit - totalCompteGestionCredit < 0
            ? (totalCompteGestionCredit - totalCompteGestionDebit).toFixed(2)
            : "0.00"),
    ]);

    // Add grand totals
    csvData.push([
        "Totaux de la balance",
        "",
        (totalCompteBilanDebit + totalCompteGestionDebit).toFixed(2),
        (totalCompteBilanCredit + totalCompteGestionCredit).toFixed(2),
        (grandTotalSdDebit).toFixed(2),
        (grandTotalSdCredit).toFixed(2),
    ]);

    exportCsv(csvData, "Balance-des-comptes.csv", ["Balance des comptes"]);
};